/**
 * @generated SignedSource<<1677541831d0c2a1f3d8e74fd0f447e7>>
 * @relayHash bbc0471f7c94268e6a04bbfc0c409087
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bbc0471f7c94268e6a04bbfc0c409087

import { ConcreteRequest } from 'relay-runtime';
export type ExaminationType = "ADDITIONAL_PARAMETER" | "ALLERGOLOGIE" | "BLOOD_CHEMISTRY" | "COAGULATION" | "HEMATOLOGY" | "LABORATORY_PHARMACY" | "LABORATORY_PROFILE" | "LONG_TERM_MEDICATION" | "MICROBIOLOGY_AND_INFECTION_SEROLOGY" | "URIN_DIAGNOSTICS";
export type laboratoryTestSelectionLookupQuery$variables = {
  language: string;
};
export type laboratoryTestSelectionLookupQuery$data = {
  readonly ch_laboratoryExaminationLookups: ReadonlyArray<{
    readonly examinationType: ExaminationType;
    readonly id: string;
    readonly isFasted: boolean;
    readonly translations: {
      readonly category: string;
      readonly description: string;
      readonly name: string;
    } | null;
  }>;
};
export type laboratoryTestSelectionLookupQuery = {
  response: laboratoryTestSelectionLookupQuery$data;
  variables: laboratoryTestSelectionLookupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "language"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "examinationType",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFasted",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "laboratoryTestSelectionLookupQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ch_LaboratoryExaminationLookup",
        "kind": "LinkedField",
        "name": "ch_laboratoryExaminationLookups",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "concreteType": "ch_LaboratoryExaminationLookupTranslation",
            "kind": "LinkedField",
            "name": "translations",
            "plural": false,
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "laboratoryTestSelectionLookupQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ch_LaboratoryExaminationLookup",
        "kind": "LinkedField",
        "name": "ch_laboratoryExaminationLookups",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": (v4/*:: as any*/),
            "concreteType": "ch_LaboratoryExaminationLookupTranslation",
            "kind": "LinkedField",
            "name": "translations",
            "plural": false,
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v1/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "bbc0471f7c94268e6a04bbfc0c409087",
    "metadata": {},
    "name": "laboratoryTestSelectionLookupQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9133a6d29b58cf5ec39cc284dbd17266";

export default node;
